export const url = process.env.REACT_APP_API_ROOT;
export const authURL = process.env.REACT_APP_AUTH_ROOT
export const getDomainOrigin = window.location.origin;
// export const aiImagesBaseUrl = process.env.AI_IMAGES_BASE_URL;
export const defaultLocale = process.env.DEFAULT_LOCALE;
